import { Monitor, Star, Sparkles, Gamepad2, Building2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import type { Stats } from '@/lib/api';

interface StatItem {
  label: string;
  value: number | undefined;
  sub: string;
  icon: LucideIcon;
  iconClass: string;
  accent?: boolean;
}

export interface StatCardsProps {
  stats: Stats | null;
  loading: boolean;
}

export function StatCards({ stats, loading }: StatCardsProps) {
  const items: StatItem[] = [
    {
      label: 'Tổng SKUs Active',
      value: stats?.active_skus,
      sub: 'Đang kinh doanh',
      icon: Monitor,
      iconClass: 'text-primary',
      accent: true,
    },
    {
      label: 'Tập trung',
      value: stats?.focal_count,
      sub: 'Focal Point',
      icon: Star,
      iconClass: 'text-cat-focal',
    },
    {
      label: 'OLED',
      value: stats?.oled_count,
      sub: 'QD-OLED + WOLED',
      icon: Sparkles,
      iconClass: 'text-cat-oled',
    },
    {
      label: 'Gaming',
      value: stats?.gaming_count,
      sub: '≥ 100Hz',
      icon: Gamepad2,
      iconClass: 'text-cat-gaming',
    },
    {
      label: 'Hãng',
      value: stats?.brand_count,
      sub: 'Brand đang bán',
      icon: Building2,
      iconClass: 'text-cat-popular',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
      {items.map((item) => (
        <Card
          key={item.label}
          className={cn(
            'overflow-hidden transition-shadow hover:shadow-md',
            item.accent && 'border-t-2 border-t-primary'
          )}
        >
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
                {item.label}
              </div>
              <item.icon className={cn('h-4 w-4', item.iconClass)} />
            </div>
            <div className="mt-2 text-3xl font-bold tabular-nums leading-none">
              {loading || item.value === undefined ? (
                <Skeleton className="h-8 w-16" />
              ) : (
                item.value.toLocaleString('vi-VN')
              )}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">{item.sub}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
